<template>
  <div class="query-container">
    <QueryView
      ref="queryView"
      :table-config="tableConfig"
      :town-selection="false"
      :region-selection="true"
      :province-selection="true"
    >
      <template #header>
        <MultiSelect
          v-model="selectedFields"
          :options="categories"
          option-label="label"
          option-value="field"
          filter
          placeholder="Categoría"
          class="w-full md:w-16rem query__category-select"
          @update:model-value="updateSelectedFields"
        >
          <template #option="slotProps">
            <div class="flex items-center custom-item-template">
              <span class="material-icons">{{ slotProps.option.icon }}</span>
              <span class="label-multiselect">{{ slotProps.option.label }}</span>
            </div>
          </template>
        </MultiSelect>
      </template>
    </QueryView>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {
  MOUNTAIN_PORTS_SCHEMA,
  MOUNTAIN_PORTS_FILTERS,
} from './query-mountain-ports-table.view-config';
import MultiSelect from 'primevue/multiselect';
import {searchMountainPort} from '@/api/mountain-port/mountain-port.api';
import {
  searchMountainPortHtml,
  searchMountainPortPdf,
  getMountainPortPdf,
} from '@/api/mountain-port/mountain-port.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
const selectedFields = ref([]);
const selectedFilters = computed(() => {
  return categories.value.map((category) => ({
    field: category.field,
    icon: category.icon,
    value: selectedFields.value.includes(category.field),
  }));
});

const categories = computed(() => {
  return MOUNTAIN_PORTS_FILTERS.map((item) => ({
    ...item,
  }));
});
//  #endregion

// #region Functions
function updateFilters() {
  queryView.value.updateAdvancedFilters(selectedFilters.value);
}
function updateSelectedFields(newFields) {
  selectedFields.value = newFields;
  updateFilters();
}
async function printMountainPort(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Puerto de montaña - ' + data.name,
      getMountainPortPdf,
    );
  }
}
async function htmlMountainPortQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery(
      'Informe Puertos de montaña',
      searchMountainPortHtml,
      'html',
    );
  }
}
async function printMountainPortQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Puertos de montaña', searchMountainPortPdf);
  }
}
async function goMountainPort({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 13;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function mountainPortToText({
  name,
  highway,
  province,
  region,
  category,
  height,
}) {
  const res = `
    Nombre: ${name}
    Autopista: ${highway}
    Provincia: ${province}
    Comunidad Autónoma: ${region}
    Categoría: ${category}
    Altura: ${height}
    `;
  return res;
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchMountainPort,
  recordToText: mountainPortToText,
  copyClipboard: copy,
  htmlQuery: htmlMountainPortQuery,
  printQuery: printMountainPortQuery,
  printRecord: printMountainPort,
  centerMap: goMountainPort,
  schema: MOUNTAIN_PORTS_SCHEMA,
  filterFields: [],
});
// #region Effects, Hooks
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.query-container {
  & :deep(.p-chip) {
    display: none;
  }
}
.label-multiselect {
  padding-top: 3px;
  padding-left: 4px;
}
</style>
